<template>
  <el-container class="setContainer">
    <el-header class="header_div">
      <!-- <i class="el-icon-back" style="float: left;font-size: 32px;line-height: 60px;"></i> -->
      <strong style="margin: 0 auto"
        >设置 - 站点{{ station }}---(版本号：{{ version }})</strong
      >
    </el-header>
    <el-container style="height: 770px; border: none">
      <el-aside
        style="
          background-color: #ffffff;
          text-align: left;
          width: auto;
          border-radius: 0 0 0 1.25rem;
        "
      >
        <el-menu
          :default-openeds="['1', '2', '3','4']"
          style="border-right: 0"
          :default-active="activeIndex"
          router
          class="el-menu-vertical-demo"
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span class="nav_title">话术管理</span>
            </template>
            <el-menu-item
              v-for="(item, idx) in talkList"
              :index="item.path"
              :key="idx"
              class="item_div"
            >
              {{ item.name }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-orange"></i>
              <span class="nav_title">MM管理</span>
            </template>
            <el-menu-item
              v-for="(item, idx) in MMList"
              :index="item.path"
              :key="idx"
              class="item_div"
            >
              {{ item.name }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-s-comment"></i>
              <span class="nav_title">对话反馈</span>
            </template>
            <el-menu-item class="item_div" index="/operations/csfeedback">
              对话反馈</el-menu-item
            >
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-s-cooperation"></i>
              <span class="nav_title">客服系统</span>
            </template>
            <el-menu-item class="item_div" index="/operations/csOptions">
              参数配置</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </el-aside>

      <div class="gray_line"></div>

      <el-main style="border-radius: 0 0 20px 0" v-if="menuShow == true">
        <router-view></router-view>
      </el-main>

      <!-- <el-dialog title="token验证" :visible.sync="dialogVisible" center width="50%" :close-on-click-modal="false"
				:close-on-press-escape="false" :show-close='false'>
				
				<el-form :model="form" label-width="120px" style="width: 80%;" ref="form">
					
					<el-form-item label="请输入token" prop="token">
						<el-input v-model="form.token" autocomplete="off"></el-input>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="checkToken">确 定</el-button>
				</div>
			</el-dialog> -->
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "operations",
  data() {
    return {
      version: "",
      station: "",
      talkList: [
        {
          name: "自定义话术",
          path: "/operations/speechCraft",
        },
        {
          name: "话术模式",
          path: "/operations/modeOptions",
        },
      ],
      MMList: [
        {
          name: "科室引擎配置",
          path: "/operations/robotset",
        },
        {
          name: "科室规则配置",
          path: "/operations/ruleset",
        },
        {
          name: "机器人接待设置",
          path: "/operations/robotreply",
        },
      ],
      activeIndex: "1",
      menuShow: false,
      form: {
        token: "",
        website: "",
      },
    };
  },
  mounted() {
    console.log(
      "operations mounted list = ",
      this.$store.state.authority.midmanList
    );
    this.version = localStorage.getItem("version");
    let site = this.util.getLocalSite();
    this.station = site.webId;
    this.checkToken();
  },
  methods: {
    async checkToken() {
      var api = "/manager/devops/admin/valid/token";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          token: localStorage.getItem("token"),
        },
      });

      if (response.resultCode == 10000) {
        if (response.data == true) {
          this.menuShow = true;
        } else {
          this.$message.error("该账号无权限进入运维管理界面");
        }
      } else {
        this.menuShow = false;
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.setContainer {
  width: 100%;
  height: 100vh;
  background: #f7fbf7;
  // background: #FFFFFF;
  margin: 0 auto;
  /* border-radius: 1.25rem; */
  /* margin-top: 5rem; */
  display: flex;
  flex-direction: row;
}

.header_div {
  @include change_title_size($title_size_normal);
  text-align: center;
  height: 4rem;
  color: white;
  display: flex;
  align-items: center;
  background-color: #409eff;
}

.el-aside {
  color: #333;
}

.el-main {
  background-color: white;
}

.gray_line {
  width: 4px;
  height: 100%;
  background: #e2e8f0;
}

.nav_title {
  @include change_size($font_size_normal);
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  margin-left: -3px;
}

.el-icon-orange,
.el-icon-setting {
  margin-left: -8px;
}

.item_div {
  @include change_size($font_size_normal);
  font-family: "arial, helvetica, sans-serif";
}
</style>
